<!--
Important:
This Component is used only for the Vue3 application
Any modifications made should be done for Vue2 component also
Vue2File: wwwroot\js\WebsitePrimary\components\VehicleCount\MitsubishiOemVehicleCount.vue
Dont forget to make the changes in both the files
Any clarifications contact Laxman
-->
<!--note:
-----
common for primary and simplify templates-->

<template>
  <div
    id="mitsubishi-oem-vehicle-count-container"
    v-if="inventoryVehicledetails"
    v-match-heights="setMatchHeightData"
    class="container vehicle-models-count inventory-slick-section g-page-section"
    :class="
      inventoryVehicledetails &&
      inventoryVehicledetails.newModels &&
      inventoryVehicledetails.newModels.length > 3
        ? 'overlay-on-vehicle'
        : ''
    "
  >
    <div class="text-center my-4 vehicle-title-wrapper">
      <h3 class="vehicle-count-title">
        {{ heading ? heading : "Today's Vehicle Inventory:" }}
      </h3>
      <a
        href="/inventory"
        class="ft-12 color-black mr-3 rotational-coupon-service-link cust-link btn-websites button-link text-center text-capitalize d-block text-underline"
        @click="onCommonLinkLogs(subHeading, '/inventory')"
      >
        {{ subHeading ? subHeading : " " }}
      </a>
      <div>
        <a
          v-if="enableCountOnPrimaryControl"
          class="no-hover color-black hover-color _theme_font_bold"
          :href="`/inventory/${
            inventoryVehicledetails.newModels[0].vehicles.certified
              ? 'cpo'
              : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
          }`"
          @click="onCommonLinkLogs(inventoryVehicledetails.totalVehicleCount, `/inventory/${
            inventoryVehicledetails.newModels[0].vehicles.certified
              ? 'cpo'
              : inventoryVehicledetails.newModels[0].vehicles.type.toLowerCase()
          }`)"
        >
          <span class="vehicle-total-count">{{ inventoryVehicledetails.totalVehicleCount }}</span>
        </a>
      </div>
    </div>
    <VSlickCarousel
      ref="slick"
      v-bind="slickOptions"
      @afterChange="handleAfterChange"
      @beforeChange="handleBeforeChange"
    >
      <template #prevArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'previous';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-left-arrow-light-format ft-24 position-absolute"
            style="cursor: pointer; z-index: 1; left: 0px; top: 45%"
          ></em>
        </div>
      </template>
      <template #nextArrow="arrowSlotProps">
        <div
          @click="
            slickDirection = 'next';
            arrowSlotProps.onClick();
          "
          :disabled="arrowSlotProps.disabled"
        >
          <em
            class="primaryicon-right-arrow-light ft-24 position-absolute"
            style="cursor: pointer; z-index: 1; right: 0px; top: 45%"
          ></em>
        </div>
      </template>
      <div
        v-for="(vehicle, index) in inventoryVehicledetails.newModels"
        :key="index"
        class="inventory-vehicle-block no-hover color-primary theme-text-color mitsubishi-oem-vehicle-count"
      >
        <div class="w-75 mx-auto">
          <div class="inventory-image">
            <a @click="logTagLinkClickEvents(vehicle)" :href="`${vehicle.vehicles.url}`">
              <img
                v-if="useoverrides"
                :src="`${vehicle.vehicles.photoURLs}&angle=01&width=300&colorcode=${vehicle.vehicles.extColorCode}&quality=85&useoverrides=${useoverrides}&type=jpeg`"
                class="img-fluid mx-auto"
                :width="imageWidth"
                :height="imageHeight"
                :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
              />
              <img
                v-else
                :src="`${vehicle.vehicles.photoURLs}&angle=01&width=300&colorcode=${vehicle.vehicles.extColorCode}&quality=85&type=jpeg`"
                class="img-fluid mx-auto"
                :width="imageWidth"
                :height="imageHeight"
                :alt="`${vehicle.vehicles.year} ${vehicle.vehicles.make} ${vehicle.vehicles.model}`"
              />
            </a>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <div class="text-center py-3 position-relative coupon-fixed-btn count-img-box">
            <div class="ft-20 color-black font-weight-bold _theme_font_bold vehicle-model-name">
              <strong>
                {{ vehicle.vehicles.year }} {{ vehicle.vehicles.make }}
                {{ vehicle.vehicles.model }}
              </strong>
            </div>

            <a
              @click="logTagLinkClickEvents(vehicle)"
              :href="`${vehicle.vehicles.url}`"
              class="my-2 no-hover"
              ><span class="color-black text-underline">View Details</span></a
            >
          </div>
        </div>
      </div>
    </VSlickCarousel>
  </div>
</template>

<script type="text/javascript">
import { SHIFT_DIGITAL_VEHICLE_COUNT_CAROUSEL_ASSET_NAME } from "../../../../js/services/ShiftDigital/ShiftDigitalConstants";
import ShiftDigitalService from "../../Events/ShiftDigital/ShiftDigitalService";
import VehicleCount from "./VehicleCount";
export default {
  mixins: [VehicleCount],
  data() {
    return {
      slickOptions: {
        groupsToShow: 1,
        dots: false,
        centerMode: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              groupsToShow: 3,
              dots: false,
              centerMode: true,
              centerPadding: "20%",
              infinite: true,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              groupsToShow: 3,
              dots: false,
              centerMode: false,
              infinite: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              groupsToShow: 2,
              groupsToScroll: 2,
              centerMode: false,
              nextArrow: `<em class="primaryicon-right-arrow-light  ft-24 position-absolute" style="cursor:pointer;z-index:1;right:0px;top:45%"></em>`,
              prevArrow: `<em class="primaryicon-left-arrow-light-format  ft-24 position-absolute" style="cursor:pointer;z-index:1;left:0px;top:45%"></em>`,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow-light  ft-24 position-absolute" style="cursor:pointer;z-index:1;right:0px;top:45%"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow-light-format  ft-24 position-absolute" style="cursor:pointer;z-index:1;left:0px;top:45%"></em>`,
      },
      currentDesign: "MitsubishiOemVehicleCount",
    };
  },
  methods: {
    handleAfterChange(event, slick, currentSlide) {
      this.vehicleCountCurrentSlide = currentSlide;
      if (this.shiftDigital) {
        let carouselClick = {
          assetPosition: currentSlide,
          assetName: SHIFT_DIGITAL_VEHICLE_COUNT_CAROUSEL_ASSET_NAME,
        };
        ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
      }
    },
  },
};

/**
 *
 *  slickOptions: {
        centerMode: true,
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        centerPadding: '300px',
        responsive: [
          {
            breakpoint: 1441,
            settings: {
              centerMode: true,
        focusOnSelect: true,
        slidesToShow: 3,
        slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
        nextArrow: `<em class="primaryicon-right-arrow bgcolor-primary _msbi_background_color" style="color:#cccccc;cursor:pointer;z-index:1"></em>`,
        prevArrow: `<em class="primaryicon-left-arrow" style="cursor:pointer;z-index:1"></em>`,
      },

 */
</script>

<style>
.inventory-vehicle-block {
  border: 1px solid transparent;
  border-bottom: 4px solid transparent;
}

.inventory-vehicle-block:hover {
  border: 1px solid #ccc;
  border-bottom: 4px solid;
  cursor: pointer;
}

.inventory-vehicle-block:hover .inventory-vehicle-count,
.no-hover:hover .inventory_total_count {
  color: #000 !important;
}

.img-ht {
  max-height: 70px;
  margin: 0 auto;
}
.vehicle-model-name {
  letter-spacing: 0px;
}
@media (max-width: 767px) {
  .inventory-vehicle-block {
    min-height: initial;
  }

  .count-img-box {
    position: initial !important;
  }
}
.count-label-default {
  font-size: 5em;
  height: 75px;
  line-height: 75px;
}

.overlay-on-vehicle.vehicle-models-count.inventory-slick-section .v-slick-slide-group {
  opacity: 0.5;
  transition: opacity 0.5s ease-in;
}
.overlay-on-vehicle.vehicle-models-count.inventory-slick-section
  .v-slick-slide-group
  .coupon-fixed-btn {
  visibility: hidden;
}
.overlay-on-vehicle.vehicle-models-count.inventory-slick-section .v-slick-slide-group.active {
  opacity: 1;
}
.overlay-on-vehicle.vehicle-models-count.inventory-slick-section
  .v-slick-slide-group.active
  .coupon-fixed-btn {
  visibility: visible;
}

.inventory-vehicle-block.mitsubishi-oem-vehicle-count {
  border: none;
}

.inventory-vehicle-block.mitsubishi-oem-vehicle-count:hover {
  border: none;
}
</style>
